<template lang="pug">
v-dialog(
  v-model="dialog"
  width="500"
)
  template(v-slot:activator="{ on }")
    v-btn(
      v-on="on"
      text
      block
    ) Reset password

  v-card
    v-card-title.headline(primary-title)
      | Reset password

    v-card-text
      v-form(
        v-model="valid"
        ref="form"
        @submit="reset"
      )
        v-text-field(
          v-if="hasToken"
          v-model="password"
          type="password"
          prepend-icon="mdi-form-textbox-password"
          label="Password"
          required
          :rules="[rules.hasUppercase, rules.hasLowercase, rules.hasNumber, rules.min, rules.hasSpecial, rules.required]"
        )

        v-text-field(
          v-else
          v-model="email"
          label="Email"
          :rules="[rules.isEmail, rules.required]"
        )

    v-divider

    v-card-actions
      v-spacer

      v-btn(
        text
        @click="close"
      ) Cancel

      v-btn(
        text
        color="primary"
        :loading="loading"
        :disabled="!valid"
        @click="reset"
      ) Reset
</template>

<script>
/* eslint-disable no-useless-escape */
export default {
  data: () => ({
    dialog: false,
    valid: false,
    loading: false,
    hasToken: false,
    password: "",

    email: "",

    rules: {
      required: (v) => v.length > 0 || "Required",
      hasUppercase: (v) =>
        /[A-Z]/.test(v) || "Upper case characters required",
      hasLowercase: (v) =>
        /[a-z]/.test(v) || "Lower case characters required",
      hasNumber: (v) => /[0-9]/.test(v) || "At least one number",
      hasSpecial: (v) =>
        /[ `!@#$%^&*()_+\-=\[\]{};':"\\|,.<>\/?~]/.test(v) ||
        "At least one special !@#$%^&*()_+-=[]{};':\"\\|,.<>/?~",
      isEmail: (v) => /.+@.+\..+/.test(v) || "E-mail must be valid",
      min: (v) => v.length >= 8 || "Min 8 characters"
    }
  }),

  mounted() {
    if (
      this.$route.query.reset
      && this.$route.query.reset != ''
    ) {
      this.dialog = true
      this.hasToken = true
    }
  },

  methods: {
    close() {
      this.dialog = false
    },

    reset() {
      if (this.$refs.form.validate()) {
        this.loading = true;
        if (this.hasToken) {
          this.axios
            .put('/auth/password/reset', {
              token: this.$route.query.reset,
              password: this.password
            })
            .then(() => {
              this.$router.push('/login')
              const payload = {
                type: "success",
                text: "Successfully updated"
              }
              this.$emit("message", payload);
              this.close();
            })
            .catch(() => {
              const payload = {
                type: "error",
                text: "Something went wrong"
              }
              this.$emit("message", payload)
            })
            .finally(() => this.loading = false)
        } else {
          this.axios
            .post('/auth/password/reset', {
              Email: this.email
            })
            .then(() => {
              this.close()
            })
            .catch(() => {
              const payload = {
                type: "error",
                text: "Something went wrong"
              };
              this.$emit("message", payload);
            })
            .finally(() => this.loading = false)
        }
      }
    }
  }
}
</script>
